import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'vg-offcanvas-header',
    template: `<ng-content></ng-content>`,
})
export class VgOffCanvasHeaderComponent {

}

@Component({
    selector: 'vg-offcanvas-body',
    template: `<ng-content></ng-content>`,
})
export class VgOffCanvasBodyComponent {

}

@Component({
    selector: 'vg-offcanvas-footer',
    template: `<ng-content></ng-content>`,
})
export class VgOffCanvasFooterComponent {

}

@Component({
    selector: 'vg-offcanvas',
    templateUrl: './vg-off-canvas.component.html',
    styleUrls: ['./vg-off-canvas.component.scss'],
    animations: [
        trigger('opacity', [
            transition(':enter', [
                style({ opacity: "0" }),
                animate('200ms', style({ opacity: "0.5" })),
            ]),
            transition(':leave', [
                animate('200ms', style({ opacity: "0" }))
            ])
        ]),
        trigger('translate', [
            transition(':enter', [
                style({ transform: 'translateX(100%)' }),
                animate('200ms', style({ transform: 'translateX(0%)' })),
            ]),
            transition(':leave', [
                animate('200ms', style({ transform: 'translateX(100%)' }))
            ])
        ]),
    ]
})
export class VgOffCanvasComponent implements OnInit {
    @Input() title: string;
    @Input() large: boolean = false;
    @Input() canBeClosed: boolean = true;
    @Output() onClose: EventEmitter<void> = new EventEmitter();

    isOpen: boolean = false;

    constructor() { }

    ngOnInit() {
        document.body.classList.remove('overflow-hidden');
    }

    open() {
        this.isOpen = true;

        document.body.classList.add('overflow-hidden');
    }

    close() {
        if (!this.canBeClosed) {
            return;
        }

        document.body.classList.remove('overflow-hidden');

        this.isOpen = false;
        this.onClose.emit();
    }

}
